import { render, staticRenderFns } from "./CRUDTournament.vue?vue&type=template&id=9da7ed0e&scoped=true&lang=pug"
import script from "./CRUDTournament.vue?vue&type=script&lang=js"
export * from "./CRUDTournament.vue?vue&type=script&lang=js"
import style0 from "./CRUDTournament.vue?vue&type=style&index=0&id=9da7ed0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da7ed0e",
  null
  
)

export default component.exports